// extracted by mini-css-extract-plugin
export default {"messages":"abh1","spacer":"PZ5V"};